import { Box, SimpleGrid, Icon, Text, Stack, Flex } from "@chakra-ui/react"
import { FcCollect, FcReading, FcPuzzle } from "react-icons/fc"

const Feature = ({ title, text, icon }) => {
  return (
    <Stack align={{ base: 'center', md: 'flex-start' }}>
      <Flex
        w={{ base: 12, md: 16 }}
        h={{ base: 12, md: 16 }}
        align={"center"}
        justify={"center"}
        color={"white"}
        rounded={"full"}
        bg={"gray.100"}
        mb={1}
      >
        {icon}
      </Flex>
      <Text fontWeight={600} color={'white'} fontSize={{ base: 'md', md: 'lg' }}>{title}</Text>
      <Text color={"white"} fontSize={{ base: 'sm', md: 'md' }} textAlign={{ base: 'center', md: 'left' }}>{text}</Text>
    </Stack>
  )
}

export default function SimpleThreeColumns() {
  return (
    <Box p={{ base: 3, md: 4 }}>
      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={{ base: 6, md: 10 }} id={"about"}>
        <Feature
          icon={<Icon as={FcCollect} w={{ base: 8, md: 10 }} h={{ base: 8, md: 10 }} />}
          title={"Immersion"}
          text={
            "At Maagarishda Hidatsa Nest, children learn Hidatsa through daily immersion—songs, stories, play, daily routine and conversation with our " + 
            "last fluent speakers and learners."
          }
        />
        <Feature
          icon={<Icon as={FcReading} w={{ base: 8, md: 10 }} h={{ base: 8, md: 10 }} />}
          title={"Curriculum"}
          text={
            "Our curriculum is built to revitalize the Hidatsa language for today and future generations. Guided by our last fluent speakers and dedicated mentors, " +
            "we teach through culture, community knowledge, and consistent practice that supports real language growth."
          }
        />
        <Feature
          icon={<Icon as={FcPuzzle} w={{ base: 8, md: 10 }} h={{ base: 8, md: 10 }} />}
          title={"Fun Engagement"}
          text={
            "We keep learning joyful and meaningful through games, songs, storytelling, and hands-on activities rooted in Hidatsa culture. With unified community support, " +
            "children and families build confidence using the language together in everyday moments."
          }
        />
      </SimpleGrid>
    </Box>
  )
}
